// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { harvestOperationId } from './HarvestOperation';
import { batchTypeEnum } from './BatchTypeEnum';
import { harvestBranchId } from './HarvestBranch';
import { invLocationId } from './InvLocation';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestStoredOutputId = (z.number());
export const harvestStoredOutput = z.object({
    id: harvestStoredOutputId,
    harvest_id: harvestId,
    source_harvest_operation_id: harvestOperationId,
    material: batchTypeEnum,
    branch_id: harvestBranchId.nullable(),
    name: z.string(),
    stored_at: z.date(),
    quantity_kg: z.string().nullable(),
    storage_location_id: invLocationId.nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestStoredOutputInitializer = z.object({
    id: harvestStoredOutputId.optional(),
    harvest_id: harvestId,
    source_harvest_operation_id: harvestOperationId,
    material: batchTypeEnum,
    branch_id: harvestBranchId.optional().nullable(),
    name: z.string(),
    stored_at: z.date().optional(),
    quantity_kg: z.string().optional().nullable(),
    storage_location_id: invLocationId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestStoredOutputMutator = z.object({
    id: harvestStoredOutputId.optional(),
    harvest_id: harvestId.optional(),
    source_harvest_operation_id: harvestOperationId.optional(),
    material: batchTypeEnum.optional(),
    branch_id: harvestBranchId.optional().nullable(),
    name: z.string().optional(),
    stored_at: z.date().optional(),
    quantity_kg: z.string().optional().nullable(),
    storage_location_id: invLocationId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestStoredOutput.js.map